// src/pages/user/manageLicense.js
import { useEffect, useState } from "react";
import Layout from "../../component/Layout";
import { Helmet } from "react-helmet-async";
import api from "../../axios";

export default function ManageLicense() {
  const [licenses, setLicenses] = useState([]);
  const [devices, setDevices] = useState([]);

  useEffect(() => {
    const username = sessionStorage.getItem("username");
    if (!username) return;
    fetchLicenses(username);
  }, []);

  const fetchLicenses = async (username) => {
    try {
      const licenseRes = await api.get(`/api/license/by-username/${username}`);
      const deviceRes = await api.get("/api/device");
      setLicenses(licenseRes.data);
      setDevices(deviceRes.data);
    } catch (error) {
      console.error("Veriler alinamadi:", error);
    }
  };

  const handleDeleteDevice = async (id) => {
    if (window.confirm("Cihazı silmek istediğinize emin misiniz?")) {
      try {
        await api.delete(`/api/device/${id}`);
        const username = sessionStorage.getItem("username");
        fetchLicenses(username);
      } catch (error) {
        console.error("Silme hatası:", error);
      }
    }
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleString("tr-TR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false
    });
  };

  const getStatusBadge = (license) => {
    const now = new Date();
    const start = new Date(license.startDate);
    const end = new Date(license.endDate);

    if (!license.isActive) return "Pasif";
    if (start > now) return "Henüz Başlamadı";
    if (end < now) return "Süresi Doldu";
    return "Aktif";
  };

  return (
    <div>
      <Helmet><title>Lisans Yönetimi</title></Helmet>
      <Layout pageTitle="Lisanslarım">
        <div className="overflow-x-auto bg-white dark:bg-gray-900 shadow rounded-lg">
          <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
            <thead className="bg-gray-50 dark:bg-gray-800">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">#</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Yazılım</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Lisans Anahtarı</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Başlangıç</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Bitiş</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Durum</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Cihazlar</th>
              </tr>
            </thead>
            <tbody className="bg-white dark:bg-gray-900 divide-y divide-gray-200 dark:divide-gray-700">
              {licenses.map((license, index) => (
                <>
                  <tr key={license.id} className="hover:bg-gray-50 dark:hover:bg-gray-800">
                    <td className="px-4 py-3 text-sm text-gray-900 dark:text-white">{index + 1}</td>
                    <td className="px-4 py-3 font-medium text-gray-800 dark:text-white">{license.softwareName}</td>
                    <td className="px-4 py-3 text-sm text-gray-600 dark:text-gray-300 break-all">{license.licenseKey}</td>
                    <td className="px-4 py-3 text-sm text-gray-600 dark:text-gray-300">{formatDate(license.startDate)}</td>
                    <td className="px-4 py-3 text-sm text-gray-600 dark:text-gray-300">{formatDate(license.endDate)}</td>
                    <td className="px-4 py-3 text-sm">
                      <span className={`px-2 py-1 text-xs font-semibold rounded-full ${
                        getStatusBadge(license) === "Aktif"
                          ? "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300"
                          : getStatusBadge(license) === "Süresi Doldu"
                          ? "bg-gray-200 text-gray-800 dark:bg-gray-700 dark:text-gray-300"
                          : getStatusBadge(license) === "Henüz Başlamadı"
                          ? "bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300"
                          : "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300"
                      }`}>
                        {getStatusBadge(license)}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-700 dark:text-gray-300">
                      {devices.filter((d) => d.licenseId === license.id && d.isApproved).length}
                    </td>
                  </tr>

                  {/* Alt satırda cihaz listesi */}
                  {devices
                    .filter((d) => d.licenseId === license.id && d.isApproved)
                    .map((device) => (
                      <tr key={`device-${device.id}`} className="bg-gray-50 dark:bg-gray-800">
                        <td></td>
                        <td colSpan="5" className="px-6 py-3 text-sm text-gray-700 dark:text-gray-300">
                          ↳ {device.deviceName} ({formatDate(device.registeredAt)})
                        </td>
                        <td className="px-4 py-3">
                          <button
                            onClick={() => handleDeleteDevice(device.id)}
                            className="bg-red-500 hover:bg-red-600 text-white text-xs px-3 py-1 rounded"
                          >
                            Sil
                          </button>
                        </td>
                      </tr>
                    ))}
                </>
              ))}
              {licenses.length === 0 && (
                <tr>
                  <td colSpan="7" className="text-center px-6 py-4 text-gray-400 dark:text-gray-500">
                    Lisans bulunamadı.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Layout>
    </div>
  );
}
